import { makeObservable } from 'mobx'

import SharedStore from 'shared/stores/shared.store'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { createTrackingLogApi, TrackingLog, TrackingLogApi } from 'shop/api/trackingLog.api'

export class TrackingLogStore extends SharedStore<TrackingLog> {
  storeName = 'TrackingLogStore'
  declare childApi: TrackingLogApi

  constructor(root: ShopRootStore) {
    super()
    makeObservable(this)
    this.childApi = createTrackingLogApi(root.apiClientV2)
  }

  trackingLog = async (data: {
    form: string
    username: string
    trackingCodeId: number
    trackingEventId?: Record<string, never> | number
    sellerId?: number
    trackingCodeForm?: string
    info?: {
      name?: string
      form?: string
      code: string
      customerToken: string | boolean
      orderId?: number
      productId?: number | string
      productPrice?: number | string
      currency?: string
      url?: string
    }
    orderId?: number
    // MAC-1766 — shared dedup key sent alongside each Pixel fire; backend
    // stores it on the TrackingLog so the CAPI worker can dedupe with Meta.
    eventId?: string
    // Meta's _fbp/_fbc cookies, snapshotted into request_signals backend-side
    // so the CAPI worker can build mid-funnel user_data.
    fbp?: string
    fbc?: string
  }) => await this.childApi.trackingLog(data)
}
